





























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import {
  HsabExpenseCategory,
  HsabExpenseResponse,
  ManagedExpenseResponse,
  ManagedExpenseType,
} from "@/shared/types";
import HsabExpenseCardRowExpenseDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseDetail.vue";
import HsabExpenseCardRowPayee from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayee.vue";
import HsabExpenseCardRowDenial from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowDenial.vue";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import HsabExpenseCardRowContent from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowContent.vue";
import HsabExpenseCardRowExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseEvidence.vue";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import HsabExpenseDetailsModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import { useThemeStore } from "@/shared/store/theme";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DebitCardTransactionModal from "@/employee/components/landing-pages/hsabank/expense/DebitCardTransactionModal.vue";

@Component({
  computed: {
    ManagedExpenseType () {
      return ManagedExpenseType;
    }
  },
  components: {
    DebitCardTransactionModal,
    GenericLoadingSpinner,
    HsabExpenseEditModal,
    HsabExpenseDetailsModal,
    HsabExpenseCardRowExpenseEvidence,
    HsabExpenseCardRowContent,
    Pill,
    HsabExpenseCardRowPayee,
    HsabExpenseCardRowExpenseDetail,
    HsabExpenseCardRowDenial,
    Button,
    CurrencyAmount,
    HsabExpenseEvidence,
  }
})
export default class HsabExpenseCardRow extends Vue {
  hsabExpenseStore = useHsabExpenseStore();
  themeStore = useThemeStore();
  expense: HsabExpenseResponse = null;

  @Prop({ required: true })
  managedExpense: ManagedExpenseResponse;

  @Prop({ default: true })
  showPlanName: boolean;

  showDetailsModal = false;
  showEditModal = false;
  showDebitCardTransactionModal = false;
  thinking = false;

  get expenseCategory (): HsabExpenseCategory {
    return this.managedExpense.expenseCategory;
  }

  async handleCardRowClick (event: UIEvent) {
    switch (this.managedExpense.managedExpenseType) {
      case ManagedExpenseType.AvailableExpense:
        this.thinking = true;
        this.expense = await this.hsabExpenseStore.loadExpenseById(this.managedExpense.expenseId);
        this.thinking = false;
        this.showEditModal = true;
        break;
      case ManagedExpenseType.SubmittedExpense:
        this.thinking = true;
        this.expense = await this.hsabExpenseStore.loadExpenseById(this.managedExpense.expenseId);
        this.thinking = false;
        this.showDetailsModal = true;
        break;
      case ManagedExpenseType.DebitCardTransaction:
        this.showDebitCardTransactionModal = true;
        break;
    }
  }

  onCloseEvent () {
    this.showEditModal = false;
  }

  onCloseDetailsEvent () {
    this.showDetailsModal = false;
  }

  oncloseDebitCardTransactionModal () {
    this.showDebitCardTransactionModal = false;
  }

  onEditSubmittedExpenseEvent () {
    this.showDetailsModal = false;
    this.showEditModal = true;
  }
}
